import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";

export default function StudizComponent() {
    return (
        <>
            <div id={'hero-container'} className={'hero-container hero-container--5g-internet hoej-uhoej darkteal'}>
                <div className={'hero-background-wrapper'}>
                    <div className={'hero-background'}/>
                </div>

                <div className={'hero-content'}>
                    <h1>
                    <span className={'hero-pre-price'}>Høj hastighed <span className={'no-wrap'}>til <strong>lav studiepris</strong></span></span>
                        <span className={'hero-price'}>
                            99<span className={'price-comma-dash'}>,-</span>
                            <span className={'price-md'}>/md.<br/>i 3 mdr.</span>
                        </span>
                        <span className={'hero-unlimited-data'}>
                            Brug rabatkoden: studiz99
                        </span>
                    </h1>
                </div>

                <div className={'address-wrap'}>
                    <h2>Indtast din adresse herunder
                        <div className={'scroll-down-arrow'}/>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>

                <p className={'conditions'}>
                    Tilbuddet gælder på udvalgte adresser og ved brug af rabatkoden &ldquo;studiz99&rdquo;.
                    Pris herefter fra 279 kr./md.
                    Min. pris i 6 mdr. fra 1.134 kr.
                    Forudsætter at man ikke har været kunde de seneste 6 mdr.
                    Rabatkoden gælder kun ved køb af TDC Fiber, Coax og 5G-internet.
                </p>
            </div>
        </>
    )
}
